import React, {useState, useEffect} from "react";
import { initialiseBaseSkins } from '../Users';
import SkinViewer from "./SkinViewer";
import FileUpload from "./FileUpload";
import CloseIcon from '@mui/icons-material/Close';

export default function SkinsManager({ pageAuthor, skins = [], currentUser, breadcrumbs, target, setTarget, addNew, edit }) {
    const defaultSkin = {
        title:"", type:"skin", groupWidth: 88, columnStart: 0, columnEnd: 8, pageTitleFont:"Source Code Pro", pageTitleColor:"#4468a2", pageSubtitleFont: "Source Code Pro",
        pageSubtitleColor: "#4468a2", pageBackgroundColor: "rgba(0, 0, 0, 0)", isBackgroundImage: 0, backgroundImage: false,
        curvedBorders: 0, groupBorders: 1, blockBorders: 0, borderColor: "#5a677c", titleBorderColor: "#5a677c", 
        groupBackgroundColor: "rgba(0, 0, 0, 0)", blockBackgroundColor: "rgba(0, 0, 0, 0)", textFont: "Source Code Pro", textSize: 14, 
        textColor: "#5a677c", linkColor: "#4468a2", linkHoverColor: "#aaacb3"
    };
    const [input, setInput] = useState(defaultSkin);
    const [pageContent, setPageContent] = useState({});

    useEffect (() => {
        setPageContent({
            pageId: 1,
            pageCode: "1",
            collectionId: null,
            authorId: 1,
            skinId: 3,
            pageOrder: 1,
            title: "Skin Viewer",
            isProfile: 0,
            groups: [
                {
                    id: 1,
                    pageId: 1,
                    order: 0,
                    title: "Example Group",
                    link: "",
                    timeCreated: null,
                    blocks: [
                        {
                            id: 1,
                            groupId: 1,
                            pageId: 1,
                            order: 0,
                            type: "text",
                            retract: "unretractable",
                            columnStart: input.columnStart,
                            columnEnd: input.columnEnd,
                            title: window.innerWidth > 600 ? "Move this block to choose your default block placement" : "On a larger screen, this block can be moved to determine default block placement",
                            content: "<p>blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah</p>"
                        }
                    ]
                },
            ],
            skin: input
        })
    }, [input]);

    useEffect(() => {
        if (target.method === "edit") {
            setInput( {
                id: target.editingItem.id,
                authorId: target.editingItem.id,
                order: target.editingItem.order,
                title: target.editingItem.title, 
                type: target.editingItem.type,
                groupWidth: target.editingItem.groupWidth,
                columnStart: target.editingItem.columnStart,
                columnEnd: target.editingItem.columnEnd,
                pageTitleFont: target.editingItem.pageTitleFont, 
                pageTitleColor:target.editingItem.pageTitleColor, 
                pageSubtitleFont: target.editingItem.pageSubtitleFont,
                pageSubtitleColor: target.editingItem.pageSubtitleColor, 
                pageBackgroundColor: target.editingItem.pageBackgroundColor,
                backgroundImage: target.editingItem.backgroundImage,
                curvedBorders: target.editingItem.curvedBorders, 
                groupBorders: target.editingItem.groupBorders, 
                blockBorders: target.editingItem.blockBorders, 
                borderColor: target.editingItem.borderColor, 
                titleBorderColor: target.editingItem.titleBorderColor, 
                groupBackgroundColor: target.editingItem.groupBackgroundColor,
                blockBackgroundColor: target.editingItem.blockBackgroundColor, 
                textFont: target.editingItem.textFont, 
                textSize: target.editingItem.textSize, 
                textColor: target.editingItem.textColor, 
                linkColor: target.editingItem.linkColor, 
                linkHoverColor: target.editingItem.linkHoverColor
            })
        }
    }, [target])

    function handleChange(event) {
        const { name, value, type, checked } = event.target;
        setInput(prevInput => ({
            ...prevInput,
            [name]: type === "checkbox"? (checked ? 1 : 0) : name === "textSize" ? Number(value) : value === "none" ? "rgba(0, 0, 0, 0)" : value
        }));
    }

    function removeBackground() {
        setInput(prevInput => ({
            ...prevInput,
            isBackgroundImage: 0,
            backgroundImage: false
        }));
    }

    function handleClose() {
        initialiseBaseSkins(currentUser.id);
        if (target.method === "edit") {
            setTarget(prev => {
                const updatedPath = prev.path.slice(0, -1);
                return {
                    method: null,
                    path: updatedPath
                };
            });
        } else if (target.method === "create") {
            setTarget((prev) => ({...prev, method : null}));
        }
        setInput(defaultSkin);
    }

    function findChildrenAtPath(items, path) {
        let current = items;

        for (const folderId of path) {
            const folder = current.find(item => (item.type === "folder" || item.type === "skinFolder") && item.id === folderId);
            if (!folder) return [];
            current = folder.children || [];
        }

        return current;
    }

    function submit() {
        if (input.title.length === 0) return;
        let newItem = {};

        if (target.method === "create") {
            const parentId = target.path.length > 0
            ? target.path[target.path.length - 1]
            : null;

            const containerItems = findChildrenAtPath(skins, target.path);
            const order = containerItems.length;

            if (input.type === "skin") {
                newItem = {
                    order,
                    parentId,
                    authorId: currentUser.id,
                    title: input.title, 
                    type: input.type,
                    groupWidth: input.groupWidth,
                    columnStart: input.columnStart,
                    columnEnd: input.columnEnd,
                    pageTitleFont: input.pageTitleFont, 
                    pageTitleColor:input.pageTitleColor, 
                    pageSubtitleFont: input.pageSubtitleFont,
                    pageSubtitleColor: input.pageSubtitleColor, 
                    pageBackgroundColor: input.pageBackgroundColor,
                    backgroundImage: input.backgroundImage,
                    curvedBorders: input.curvedBorders, 
                    groupBorders: input.groupBorders, 
                    blockBorders: input.blockBorders, 
                    borderColor: input.borderColor, 
                    titleBorderColor: input.titleBorderColor, 
                    groupBackgroundColor: input.groupBackgroundColor,
                    blockBackgroundColor: input.blockBackgroundColor, 
                    textFont: input.textFont, 
                    textSize: input.textSize, 
                    textColor: input.textColor, 
                    linkColor: input.linkColor, 
                    linkHoverColor: input.linkHoverColor
                };
            } else {
                newItem = {
                    order,
                    parentId,
                    title: input.title, 
                    type: input.type,
                }
            }

            addNew(newItem);
            setInput(defaultSkin);
            setTarget(prev => ({ ...prev, method: null }));
            initialiseBaseSkins(currentUser.id);
        }

        if (target.method === "edit") {
            if (input.type === "skin") {
                newItem = {
                    id: target.editingItem.id,
                    folderId: target.editingItem.folderId,
                    authorId: target.editingItem.authorId,
                    order: target.editingItem.order,
                    type: input.type,
                    title: input.title, 
                    groupWidth: input.groupWidth,
                    columnStart: input.columnStart,
                    columnEnd: input.columnEnd,
                    pageTitleFont: input.pageTitleFont, 
                    pageTitleColor:input.pageTitleColor, 
                    pageSubtitleFont: input.pageSubtitleFont,
                    pageSubtitleColor: input.pageSubtitleColor, 
                    pageBackgroundColor: input.pageBackgroundColor,
                    backgroundImage: input.backgroundImage,
                    curvedBorders: input.curvedBorders, 
                    groupBorders: input.groupBorders, 
                    blockBorders: input.blockBorders, 
                    borderColor: input.borderColor, 
                    titleBorderColor: input.titleBorderColor, 
                    groupBackgroundColor: input.groupBackgroundColor,
                    blockBackgroundColor: input.blockBackgroundColor, 
                    textFont: input.textFont, 
                    textSize: input.textSize, 
                    textColor: input.textColor, 
                    linkColor: input.linkColor, 
                    linkHoverColor: input.linkHoverColor
                };
            } else {
                newItem = {
                    type: input.type,
                    id: target.editingItem.id,
                    title: input.title,
                    authorId: currentUser.id,
                    parentId: target.editingItem.parentId,
                    order: target.editingItem.order
                }
            }

            edit(newItem);
            setInput(defaultSkin);
            setTarget(prev => ({ ...prev, method: null }));
            initialiseBaseSkins(currentUser.id);
        }
    }

    return (
        <div>
            {pageContent?.pageId === 1 && input.type==="skin" && <SkinViewer pageAuthor={pageAuthor} pageContent={pageContent} setInput={setInput}/>}
            <div id="folder-create-container">
                <CloseIcon className="manager-create-close" onClick={handleClose}/>
                <div id="skin-create">
                    {target.method === "create" && 
                    <div id="skin-create-type">
                        <div>
                            <select name="type" onChange={handleChange} value={input.type} >
                                <option value="skin">skin</option>
                                <option value="skinFolder">folder</option>
                            </select>
                        </div>
                    </div>
                    }
                    {input.type === "skinFolder" &&
                    <div>
                        <div>
                            <label> folder name:
                                <input name="title" onChange={handleChange} value={input.title} placeholder="folder title" type="text"/>
                            </label>
                        </div>
                    </div>
                    }
                    {input.type === "skin" &&
                    <>
                        <p style={{fontSize: "14px"}}>for colour inputs, you can put any valid CSS colour input, such as hex codes, rgb, rgba, "none", and the standard list of colour names.</p>
                        <div className="skin-create-section">
                            <div>
                                <label> skin name: 
                                    <input name="title" onChange={handleChange} value={input.title} placeholder="skin title" type="text"/>
                                </label>
                            </div>
                            <div>
                                <label> group width (% of the screen): 
                                    <input name="groupWidth" onChange={handleChange} value={input.groupWidth} placeholder="group width" type="text"/>
                                </label>
                            </div>
                        </div>
                        <div className="skin-create-section">
                            <div>
                                <label> page title font:
                                    <select name="pageTitleFont" onChange={handleChange} value={input.pageTitleFont}>
                                        <option value="Times New Roman" className="ql-font-times-new-roman">Times New Roman</option>
                                        <option value="Georgia" className="ql-font-georgia">Georgia</option>
                                        <option value="Arial" className="ql-font-arial">Arial</option>
                                        <option value="Verdana" className="ql-font-verdana">Verdana</option>
                                        <option value="Courier New" className="ql-font-courier-new">Courier New</option>
                                        <option value="Source Code Pro" className="ql-font-source-code-pro">Source Code Pro</option>
                                        <option value="Impact" className="ql-font-impact">Impact</option>
                                        <option value="Comic Sans MS" className="ql-font-comic-sans-ms">Comic Sans MS</option>
                                        <option value="Papyrus" className="ql-font-papyrus">Papyrus</option>
                                    </select>
                                </label>
                                <label> page title colour:
                                    <input name="pageTitleColor" onChange={handleChange} value={input.pageTitleColor} placeholder="page title colour" type="text"/>
                                </label>
                                <label> page subtitle font:
                                    <select name="pageSubtitleFont" onChange={handleChange} value={input.pageSubtitleFont}>
                                        <option value="Times New Roman" className="ql-font-times-new-roman">Times New Roman</option>
                                        <option value="Georgia" className="ql-font-georgia">Georgia</option>
                                        <option value="Arial" className="ql-font-arial">Arial</option>
                                        <option value="Verdana" className="ql-font-verdana">Verdana</option>
                                        <option value="Courier New" className="ql-font-courier-new">Courier New</option>
                                        <option value="Source Code Pro" className="ql-font-source-code-pro">Source Code Pro</option>
                                        <option value="Impact" className="ql-font-impact">Impact</option>
                                        <option value="Comic Sans MS" className="ql-font-comic-sans-ms">Comic Sans MS</option>
                                        <option value="Papyrus" className="ql-font-papyrus">Papyrus</option>
                                    </select>
                                </label>
                                <label> page subtitle colour: 
                                    <input name="pageSubtitleColor" onChange={handleChange} value={input.pageSubtitleColor} placeholder="Page Subtitle Colour" type="text"/>
                                </label>
                                <label> page background colour:
                                    <input name="pageBackgroundColor" onChange={handleChange} value={input.pageBackgroundColor} placeholder="Page Background Colour" type="text"/>
                                </label>
                            </div>
                            <div>
                                <label>background image: </label>
                                <FileUpload type="background" input={input} setInput={setInput}/>
                                <div>
                                    <button className="pfp-settings-button settings-button" onClick={removeBackground}>remove background image</button>
                                </div>
                            </div>
                        </div>

                        <div className="skin-create-section">
                            <div>
                                <label className="folder-checkbox">curved borders?
                                    <input type="checkbox" 
                                        name="curvedBorders" 
                                        onChange={handleChange}
                                        checked={input.curvedBorders === 1}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                                <label className="folder-checkbox">group borders visible?
                                    <input type="checkbox" 
                                        name="groupBorders" 
                                        onChange={handleChange}
                                        checked={input.groupBorders === 1}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                                <label className="folder-checkbox">block borders visible?
                                    <input type="checkbox" 
                                        name="blockBorders" 
                                        onChange={handleChange}
                                        checked={input.blockBorders === 1}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                                <label> border colour: 
                                    <input name="borderColor" onChange={handleChange} value={input.borderColor} placeholder="border colour" type="text"/>
                                </label>
                                <label> title underline colour: 
                                    <input name="titleBorderColor" onChange={handleChange} value={input.titleBorderColor} placeholder="title border colour" type="text"/>
                                </label>
                                <label> group background colour:
                                    <input name="groupBackgroundColor" onChange={handleChange} value={input.groupBackgroundColor} placeholder="group background colour" type="text"/>
                                </label>
                                <label> block background colour:
                                    <input name="blockBackgroundColor" onChange={handleChange} value={input.blockBackgroundColor} placeholder="block background colour" type="text"/>
                                </label>
                            </div>
                            <div>
                                <label> default text font:
                                    <select name="textFont" onChange={handleChange} value={input.textFont}>
                                        <option value="Times New Roman" className="ql-font-times-new-roman">Times New Roman</option>
                                        <option value="Georgia" className="ql-font-georgia">Georgia</option>
                                        <option value="Arial" className="ql-font-arial">Arial</option>
                                        <option value="Verdana" className="ql-font-verdana">Verdana</option>
                                        <option value="Courier New" className="ql-font-courier-new">Courier New</option>
                                        <option value="Source Code Pro" className="ql-font-source-code-pro">Source Code Pro</option>
                                        <option value="Impact" className="ql-font-impact">Impact</option>
                                        <option value="Comic Sans MS" className="ql-font-comic-sans-ms">Comic Sans MS</option>
                                        <option value="Papyrus" className="ql-font-papyrus">Papyrus</option>
                                    </select>
                                </label>
                                <label> default text size:
                                    <select name="textSize" onChange={handleChange} value={input.textSize}>
                                        <option value={8}>8px</option>
                                        <option value={10}>10px</option>
                                        <option value={12}>12px</option>
                                        <option value={14}>14px</option>
                                        <option value={16}>16px</option>
                                        <option value={20}>20px</option>
                                        <option value={24}>24px</option>
                                        <option value={32}>32px</option>
                                        <option value={48}>48px</option>
                                        <option value={64}>64px</option>
                                    </select>
                                </label>
                                <label> default text colour:
                                    <input name="textColor" onChange={handleChange} value={input.textColor} placeholder="default text colour" type="text"/>
                                </label>
                                <label> default link colour:
                                    <input name="linkColor" onChange={handleChange} value={input.linkColor} placeholder="default link colour" type="text"/>
                                </label>
                                <label> default link hover colour:
                                    <input name="linkHoverColor" onChange={handleChange} value={input.linkHoverColor} placeholder="default link hover colour" type="text"/>
                                </label>
                            </div>
                        </div>
                    </>
                    }
                    <div id="skin-submit-container">
                        <div>
                            <p style={{fontSize: "14px"}}>make sure you remember to title your skin.</p>
                            <button id="folder-submit-button" className="settings-button" onClick={submit}>submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            
    )
}